import { TimeSquare, Document, Activity, Filter, Work, Chart, TickSquare, Category, People, Message, Chat, Setting, Bag2, Graph, Paper, Calendar } from "react-iconly";
import { MdOutlineFlightTakeoff, MdOutlineInsertChart, MdOutlineAreaChart, MdOutlineTextSnippet } from "react-icons/md";

const pages = [
    {
        id: "dashboard",
        title: "Dashboard",
        navLink: "/dashboard",
        icon: <Category set="curved" size='small' />,
    },
    {
        id: "apms",
        title: "Support Desk",
        icon: <Document set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "apms-dashboard",
                title: "Dashboard",
                navLink: "/apms-dashboard",
            },
            {
                id: "apms-tickets",
                title: "Tickets",
                navLink: "/Tickets",
            },
            {
                id: "apms-tickets-review",
                title: "Tickets Review",
                navLink: "/TicketReview",
            },
            {
                id: "apms-logwork",
                title: "Log Time",
                navLink: "/LogWork",
            },
            {
                id: "apms-projects",
                title: "Projects",
                navLink: "/Projects",
            },
            {
                id: "apms-subprojects",
                title: "Sub Projects",
                navLink: "/sub-projects",
            },
            {
                id: "apms-customers",
                title: "Customers",
                navLink: "/Customers",
            },            
        ],
    },
    {
        id: "demandManagement",
        title: "Demand Management",
        navLink: "/demand-list",
        icon: <Graph set="curved" size='small' />,
    },
    {
        id: "teamSync",
        title: "Team Sync",
        icon: <People set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "task-planner",
                title: "Planner",
                navLink: "/taskPlanner",
            },
            {
                id: "project-calendar",
                title: "Project Calendar",
                navLink: "/projectCalendar",
            },
            {
                id: "predefined-goals",
                title: "Predefined Goals",
                navLink: "/predefinedGoals",
            },
            {
                id: "cluster-analysis",
                title: "Cluster Analysis",
                navLink: "/clusterAnalysis",
            },
        ]
    },
    {
        id: "task",
        title: "Tasks",
        navLink: "/tasklist",
        icon: <Filter set="curved" size='small' />,
    },
    {
        id: "kit",
        title: "Kit",
        navLink: "/kit",
        icon: <Work set="curved" size='small' />,
    },
    {
        id: "expense-claim-menu",
        title: "Expense Claim",
        icon: <Document set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "expense-claim",
                title: "Expense Claim",
                navLink: "/expenseclaim",
            },
        ],
    },
    {
        id: "sales",
        title: "Sales",
        icon: <Activity set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "opportunity",
                title: "Opportunity",
                navLink: "/opportunity",
            },
            {
                id: "flexiquote",
                title: "Flexi Quote",
                navLink: "/flexiquote",
            },
            {
                id: "sales-quotation",
                title: "Sales Quotation",
                navLink: "/salesquotation",
            },
            {
                id: "sales-order",
                title: "Sales Order",
                navLink: "/salesorder",
            },
            {
                id: "Invoice Request",
                title: "Invoice Request",
                navLink: "/invoicerequest",
            },
        ],
    },
    {
        id: "purchase",
        title: "Purchase",
        icon: <Bag2 set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "purchase-order",
                title: "Purchase Order",
                navLink: "/purchaseorder",
            },
        ],
    },
    {
        id: "expense-advance-menu",
        title: "Employee Advance",
        icon: <People set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "employee-advance",
                title: "Employee Advance",
                navLink: "/employeeadvance",
            },
        ],
    },
    {
        id: "time-sheet",
        title: "Time Sheet",
        icon: <TimeSquare set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "time-sheet-report",
                title: "Time Sheet Report",
                navLink: "/timeSheetList",
            },
            {
                id: "time-sheet-sub",
                title: "Time Sheet",
                navLink: "/timesheet",
            },
        ],
    },
    {
        id: "approvals",
        title: "Approvals",
        icon: <TickSquare set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "approvals-sub",
                title: "Approvals",
                navLink: "/approvals",
            },
            {
                id: "faildapprovals-sub",
                title: "Failed Approvals",
                navLink: "/failedapprovals",
            }
        ],
    },
    {
        id: "email",
        title: "Email",
        icon: <Message set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "credentials",
                title: "Credential",
                navLink: "/emailcredential",
            },
            {
                id: "content",
                title: "Content",
                navLink: "/emailcontent",
            }
        ],
    },
    {
        id: "sms",
        title: "SMS",
        navLink: "/sms",
        icon: <Chat set="curved" size='small' />,
        submenu: true,
        children: [
            {
                id: "viewpatterns",
                title: "View Patterns",
                navLink: "/smsviewpatterns",
            },
            {
                id: "createpattern",
                title: "Create Pattern",
                navLink: "/smscreatepattern",
            }
        ],
    },
    {
        id: "settings",
        title: "Settings",
        navLink: "/settings",
        icon: <Setting set="curved" size='small' />,
    },
    {
        id: "reports",
        title: "Reports",
        navLink: "/reportlist",
        icon: <Chart set="curved" size='small' />,
    },
    {
        id: "custom-reports",
        title: "Custom Reports",
        navLink: "/custom-reports",
        icon: <Paper set="curved" size='small' />,
    },
    {
        id: "schedule-reports",
        title: "Schedule Reports",
        navLink: "/schedule-reports",
        icon: <Calendar set="curved" size='small' />,
    },
    {
        id: "trip",
        title: "Trip",
        navLink: "/trips",
        icon: <MdOutlineFlightTakeoff set="curved" style={{ fontSize: '16px' }} />,
    },
    {
        id: "Power BI",
        title: "Power BI",
        navLink: "/powerbi",
        icon: <MdOutlineInsertChart set="curved" style={{ fontSize: '16px' }} />,
    },
    {
        id: "Payroll Report",
        title: "Payroll Report",
        navLink: "/payrollreport",
        icon: <MdOutlineAreaChart set="curved" style={{ fontSize: '16px' }} />,
    },
    {
        id: "invoiceengine",
        title: "Invoice Engine",
        navLink: "/invoiceengine",
        icon: <MdOutlineTextSnippet set="curved" style={{ fontSize: '16px' }} />,
    },

];

export default pages;